export default __webpack_public_path__ + "static/216-d76020f1850d7ce883168568c90d6756.gif";